import { PlansPlanMode } from '../../../api/types'
import { PlansListErrorState } from '../../lumpsum-ui-components/PlansListErrorState'

type RebalancePlansListErrorStateProps = {
  onRetry: () => void
}

export function RebalancePlansListErrorState({ onRetry }: RebalancePlansListErrorStateProps) {
  return <PlansListErrorState planMode={PlansPlanMode.REBALANCE} onRetry={onRetry} />
}
